import {Router, ActivatedRoute, Params} from '@angular/router';
import {Component, OnInit} from '@angular/core';
import {PickUpListService} from '../shared/pick-up-list.service';
import {isArray} from 'lodash';
import {Observable} from 'rxjs/Observable';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {SearchOptions} from '../models/search-options';
import {CuiBaseComponent} from '@cicero/webui/lib/core/shared/base-component';

/**
 * URL query params used to for deep linking to a filled out search form.
 */
export interface QueryParams {
  branch?: string;
  department?: string[];
  location?: string[];
  sublocation?: string[];
  materialGroup?: string[];
  pickupBranch?: string[];
}

/**
 * A search form for a pick-up list.
 */
@Component({
  selector: 'app-search-form',
  templateUrl: './search-form.component.html',
  styleUrls: ['./search-form.component.scss']
})
export class SearchFormComponent extends CuiBaseComponent implements OnInit {
  searchForm = new FormGroup({
    branch: new FormControl(undefined, Validators.required),
    department: new FormControl([]),
    location: new FormControl([]),
    sublocation: new FormControl([]),
    materialGroup: new FormControl([]),
    pickupBranch: new FormControl([])
  });

  options: Observable<SearchOptions>;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public pickUpList: PickUpListService) {
    super();
  }

  ngOnInit(): void {
    this.options = this.pickUpList.getSearchOptions();

    // Update the form when the url changes
    const querySub = this.route.queryParams
      .map(params => this.paramsToQueryParams(params))
      .subscribe(query => this.searchForm.patchValue(query));

    // Update the url when the form changes
    const valueChangesSub = this.searchForm.valueChanges
      .subscribe(params => this.router.navigate([], {queryParams: params, replaceUrl: true}));

    // Pick the first branch as default, if no branch is selected
    const optionsSub = this.options
      .filter(() => !this.searchForm.controls['branch'].value)
      .filter(options => !!options.branches[0])
      .subscribe(options => this.searchForm.controls['branch'].setValue(options.branches[0].id));

    this.pushSubscription(querySub, valueChangesSub, optionsSub);
  }

  reset() {
    this.searchForm.patchValue({
      department: [],
      location: [],
      sublocation: [],
      materialGroup: [],
      pickupBranch: []
    });
  }

  /**
   * Converts query parameters into a search query object used by the search form.
   * @param params
   * @returns {QueryParams}
   */
  private paramsToQueryParams(params: Params): QueryParams {
    const queryParams: QueryParams = {};

    const wrapInArray = (value: any | any[]) => isArray(value) ? value : [value];

    if (params.branch) {
      queryParams.branch = params.branch;
    }

    if (params.department) {
      queryParams.department = wrapInArray(params.department);
    }

    if (params.location) {
      queryParams.location = wrapInArray(params.location);
    }

    if (params.sublocation) {
      queryParams.sublocation = wrapInArray(params.sublocation);
    }

    if (params.materialGroup) {
      queryParams.materialGroup = wrapInArray(params.materialGroup);
    }

    if (params.pickupBranch) {
      queryParams.pickupBranch = wrapInArray(params.pickupBranch);
    }

    return queryParams;
  }
}



// WEBPACK FOOTER //
// ./src/app/pick-up-list/search-form/search-form.component.ts